import type { FaireProductEntity } from "../../entity_types/product";

export const p_ft9jcfj7m9: FaireProductEntity = {
  token: "p_ft9jcfj7m9",
  type: "product",
  name: "Moroccan Cone Glassware Large - Blue",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/ffa4851a53b8e0758741d6a617a3ec1f8921ec6af217981e0748d972a9b6a611.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78c19e420e5c2cf5b4af2049e186302fd5531991a16ae4f6954052a19a00b7cc.jpeg",
    "https://cdn.faire.com/fastly/577864d672a7062a034510deeb4598ba9dde0e42e3ce5d242b3d392538bc82b3.jpeg",
    "https://cdn.faire.com/fastly/8d843e329d0ed993eaea9f9b5d66b50f68d19c3d7471296ed5243c6b6118484e.jpeg",
    "https://cdn.faire.com/fastly/84c22145cc75956a05179ff15283753c226e0c82bfbdeeae04480afea1c02438.jpeg",
    "https://cdn.faire.com/fastly/e66bd5e5b6fd62a1e3305ca108bbc3fe551870faa73fdfd7c4ced2eea3563603.jpeg",
    "https://cdn.faire.com/fastly/d2ec92ea284d082cc23f372188d8708c94a00f211fb0b5091ba05dfa89c19c5e.jpeg",
    "https://cdn.faire.com/fastly/530c485ec28fd2962803385ac68460d941b2cff1f9516dbc3fdc41694d0442b8.jpeg",
    "https://cdn.faire.com/fastly/84be0b11d448f908237eb1f7d1cd6a708dc4d26272af85602fc6563ca2fc5968.jpeg",
    "https://cdn.faire.com/fastly/a34b8b95f0a48e73301dbffdc785a329a63d496ae475559651afd8e886fcadbc.jpeg",
  ],
  priceDollars: 4.2,
  description:
    '**Packaged in sets of 6** - 24 single glasses in a master\nSee separate listings for each color option.\n\nThe sleek and simple design of these hand-blown cone shaped glasses are a testament to the style and skill of the artisans who make them. Used for all types of beverages or as little vases to decorate each table setting, you will enjoy the feel of them in your hand as you toast the joys of the day. Works beautifully as a floral vase, too!\n\nOur Moroccan glassware sets come in four distinct shades of transparent glass (Clear, Amber, Blue & Green). The handblown construction is evident in the bubbles suspended in the glass itself, and the organic forms that the vessels take.\n\nMade from recycled beer and wine bottles, these sets are a second act for glass that would otherwise be sent to landfills. \n\nLarge Cone: bottom diameter 3", top diameter 2.5" / 4.75" height. Capacity: 12 fl oz\n\nPackaged in sets of 6 in traditional Moroccan gift packaging.',
  tags: [],
  msrpDollars: 8.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:24.646Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
